import { SearchOutlined } from '@ant-design/icons';
import { Input, List, Switch } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { Role, User, UserRole } from '../../../models';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';

export function RoleUserSwitch(props: { roleId?: string; user?: User; userRoleId?: string; canEdit?: boolean }) {
  const [userRoleId, setUserRoleId] = useState(props.userRoleId);
  const [loading, setLoading] = useState(false);

  const addUserRole = () => {
    setLoading(true);

    const body = {
      roleId: props.roleId,
    };

    apiClient
      .post(`users/${props.user?.id}/roles`, body)
      .then((response: any) => {
        setUserRoleId(response.data.id);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const removeUserRole = () => {
    setLoading(true);

    apiClient
      .delete(`users/${props.user?.id}/roles/${props.roleId}`)
      .then(() => {
        setUserRoleId(undefined);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onSwitchChange = () => {
    if (userRoleId) {
      removeUserRole();
    } else {
      addUserRole();
    }
  };

  return (
    <List.Item
      actions={[<Switch checked={userRoleId !== undefined} loading={loading} onChange={onSwitchChange} disabled={!props.canEdit} />]}
    >
      <List.Item.Meta title={props.user?.fullName} description={props.user?.email} />
    </List.Item>
  );
}

export function RoleUsersForm(props: { role?: Role }) {
  const { user } = useContext(UserContext);

  const [allUsers, setAllUsers] = useState<User[]>();
  const [users, setUsers] = useState<User[]>();
  const [userRoles, setUserRoles] = useState<UserRole[]>();
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'roles.edit'));
  }, [user]);

  useEffect(() => {
    apiClient
      .get('users')
      .then((response: any) => {
        setAllUsers(response.data);
        setUsers(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, []);

  useEffect(() => {
    apiClient
      .get(`roles/${props.role?.id}/users`)
      .then((response: any) => {
        setUserRoles(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [props.role?.id]);

  const onSearchChange = (e: any) => {
    const search = (e.target.value as string).toLocaleLowerCase();
    const filteredUsers = allUsers?.filter(
      u => (u.fullName && u.fullName.toLocaleLowerCase().includes(search)) || (u.email && u.email.toLowerCase().includes(search)),
    );
    setUsers(filteredUsers);
  };

  return (
    <>
      <Input placeholder="Arama" prefix={<SearchOutlined />} style={{ marginBottom: '1rem' }} onChange={onSearchChange} />
      <List
        itemLayout="horizontal"
        dataSource={users}
        renderItem={(user: User) => {
          const userRole = userRoles?.find(ur => ur.user?.id === user.id);
          return <RoleUserSwitch roleId={props.role?.id} user={user} userRoleId={userRole?.id} canEdit={canEdit} />;
        }}
      />
    </>
  );
}
